import { useLocale, useTranslations } from 'next-intl';
import { DatePicker } from '@/component/DateRange';
import { showFullDate } from '@/utils/common';
import styles from './DateRange.module.css';
import { useAvailabilityPeriods } from '../availability_periods';
import { maxDate, minDate } from '../constants';
import { useWatchDateQuery } from '../hooks';

export const InfoDateRange = ({
  priceStartDate,
  priceEndDate,
  daysAmount,
  city,
  calendar = [],
  startTransition,
}) => {
  const locale = useLocale();
  const t = useTranslations();

  const {
    disabledDay,
    disabledDates,
    startValue,
    endValue,
    setValue,
    getMinimumDays,
    getDaysRequirement,
  } = useAvailabilityPeriods({
    calendar,
    queryDates: { startDate: priceStartDate, endDate: priceEndDate },
  });

  const onChange = (selection) => {
    const { startDate, endDate } = selection;

    setValue({ startValue: startDate, endValue: endDate });
  };

  useWatchDateQuery({ startValue, endValue, delay: 2000, startTransition });

  return (
    <div className={styles.datepicker}>
      <div className="flex flex-col gap-[6px]">
        <h4 className="text-slate-700 text-lg font-semibold tracking-tight">
          {daysAmount} {t('nights-in').slice(0, daysAmount === 1 ? 5 : 6)}{' '}
          {t('listings.result.title-after')} {city}
        </h4>
        <p className="text-slate-500 text-sm leading-tight">
          {priceStartDate && priceEndDate
            ? `${showFullDate(priceStartDate, locale)} - ${showFullDate(
                priceEndDate,
                locale
              )}`
            : ''}
        </p>
      </div>

      <section className={`${styles.dropdown} date-picker-details`}>
        <DatePicker
          value={{
            startDate: startValue || null,
            endDate: endValue || null,
          }}
          onChange={onChange}
          disabledDay={disabledDay}
          disabledDates={disabledDates}
          getMinimumDays={getMinimumDays}
          getDaysRequirement={getDaysRequirement}
          minDate={minDate}
          maxDate={maxDate}
          isBorderVisible
          isFooterHidden
        />
      </section>
    </div>
  );
};
